import React from "react";
import contactMailIcon from '../../../image/Icons/contact_mail.svg';
import locationCityIcon from '../../../image/Icons/location_city.svg';
import creditCardIcon from '../../../image/Icons/credit_card.svg';
import { FormGroup, ControlLabel, FormControl, Col, Checkbox } from '../compat/BootstrapCompat';
import {Typeahead} from 'react-bootstrap-typeahead';
import InfoTooltip from '../compat/InfoTooltip';
import TncTrial from './tncTrial'
import TncOneMonth from './tncOneMonth'
import TncGeneral from './tncGeneral'
import ErrorMessages from './checkoutErrorMessages';
import IndustrySelector from './industrySelector';
import AccountSelector from './accountSelector';

const containsPOBox = (str) => {
  if (!str) {
    return false;
  }
  const lowerCaseStr = str.toLowerCase();
  return (
    lowerCaseStr.includes("po box") ||
    lowerCaseStr.includes("pobox") ||
    lowerCaseStr.includes("po box")
  );
}

export default class CustomerForm extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      mobile: false
    }
  }

  /* istanbul ignore next */
  componentDidMount() {
    if(/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent) ){
      this.setState({
        mobile:true
      })
    }
  }

  /* istanbul ignore next*/
  orderSummaryFocus() {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  render(props){
    const tooltipContact = 'Please choose your preferred contact method in the event we need to contact you about your order.'

    const tooltipStreetAddress = 'Example unit address format "UNIT 1, 5 Street Name"'

    let classNames = require('classnames');
    let titleClass= classNames({
      'form-error-border':this.props.errorMessages.title,
      '': !this.props.errorMessages.title
    })
    let nameClass= classNames({
      'form-error-border':this.props.errorMessages.name,
      '': !this.props.errorMessages.name
    })
    let mobileNumberClass= classNames({
      'form-error-border':this.props.errorMessages.mobileNumber,
      '': !this.props.errorMessages.mobileNumber
    })
    let emailClass= classNames({
      'form-error-border':this.props.errorMessages.email,
      '': !this.props.errorMessages.email
    })
    let singleAddressLineClass= classNames({
      'form-error-border':this.props.errorMessages.singleAddressLine,
      '': !this.props.errorMessages.singleAddressLine
    })
    let streetAddressClass= classNames({
      'form-error-border':this.props.errorMessages.streetAddress || this.props.errorMessages.streetAddressFormat,
      '': !this.props.errorMessages.streetAddress
    })
    let suburbCityClass= classNames({
      'form-error-border':this.props.errorMessages.suburbCity,
      '': !this.props.errorMessages.suburbCity
    })
    let stateClass= classNames({
      'form-error-border':this.props.errorMessages.state,
      '': !this.props.errorMessages.state
    })
    let postcodeClass= classNames({
      'form-error-border':this.props.errorMessages.postcode,
      '': !this.props.errorMessages.postcode
    })
    let roleClass= classNames({
      'form-error-border':this.props.errorMessages.role,
      '': !this.props.errorMessages.role
    })
    let abnClass= classNames({
      'form-error-border':this.props.errorMessages.abn,
      '': !this.props.errorMessages.abn
    })
    let abnManualClass= classNames({
      'form-error-border':this.props.errorMessages.abnManual,
      '': !this.props.errorMessages.abnManual
    })
    let legalEntityNameClass= classNames({
      'form-error-border':this.props.errorMessages.legalEntityName,
      '': !this.props.errorMessages.legalEntityName
    })
    let businessNameClass= classNames({
      'form-error-border':this.props.errorMessages.businessName,
      '': !this.props.errorMessages.businessName
    })
    let businessTermsClass= classNames({
      'red-text body':this.props.errorMessages.businessTerms,
      'body': !this.props.errorMessages.businessTerms
    })
    let termsClass= classNames({
      'red-text':this.props.errorMessages.terms,
      '': !this.props.errorMessages.terms
    })
    let trialTermsClass= classNames({
      'red-text':this.props.errorMessages.trialTerms,
      '': !this.props.errorMessages.trialTerms
    })

    let paymentSectionClass = classNames({
      'col-sm-12 margin-top-10': !this.state.mobile,
      'col-sm-12 margin-top-10 no-padding': this.state.mobile
    })

    let businessCheckbox = classNames({
      'col-sm-6 col-sm-offset-4': !this.state.mobile,
      'col-sm-6 col-sm-offset-4 no-padding': this.state.mobile
    })

    let abnManualTextClassValue = classNames({
      'col-sm-6 checkout-body': !this.state.mobile,
      'col-sm-6 no-padding checkout-body': this.state.mobile
    })

    let abnManualTextClassLabel = classNames('col-sm-4')

    let eofycouponApplied = false
    if(this.props.couponEntity != null && this.props.couponEntity.code === "EOFY 2019 Prepay"){
      eofycouponApplied = true
    }

    return (
      <div className="row white-bg padding-20 no-margin">
        <form componentclass="fieldset">
          <div className="registration-h6">
          <i className="form-error-messages body-semibold">*</i> Mandatory field unless stated otherwise
          </div>
          <br/>
          <div className="row no-margin">
            <div className="col-sm-12 no-padding">
              <div className="row no-margin">
                <div className="col-xs-12 no-padding">
                  <div className="section-header heading3  registration-h6">
                    <img src={contactMailIcon}/>
                    Account Details
                  </div>
                </div>
              </div>
              <AccountSelector
                onInputChange={this.props.onInputChange}
                customerDetails={this.props.customerDetails}
                errorMessages={this.props.errorMessages}
                accounts = {this.props.login.accounts}
                accountsLoader = {this.props.login.accountsLoader}
                onAccountSelectorChange = {this.props.onAccountSelectorChange}
                onManualAccountInputChange = {this.props.onManualAccountInputChange}
                onAccountTypeSelectorChange = {this.props.onAccountTypeSelectorChange}
              />
            </div>
          </div>
          <hr/>
          <div className="row no-margin">
            <div className="col-sm-12 no-padding">
              <div className="row no-margin">
                <div className="col-xs-12 no-padding">
                  <div className="section-header heading3 registration-h6">
                    <img src={contactMailIcon}/>
                    Customer Details
                  </div>
                </div>
              </div>
              <FormGroup controlId="title" className="row">
                <Col sm={4}>
                  <ControlLabel className='body-semibold'>
                    Title
                    <i className="form-mandatory-fields">*</i>
                  </ControlLabel>
                </Col>
                <Col sm={6}>
                  <FormControl
                    className={titleClass}
                    componentClass="select"
                    disabled = {this.props.disabled.title}
                    id="title"
                    name="title"
                    value={this.props.customerDetails.title}
                    onChange={(e)=>{this.props.onInputChange(e)}}
                  >
                    <option value="">--Select Title--</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Prof.">Prof.</option>
                    <option value="Mx.">Mx.</option>
                  </FormControl>
                  {this.props.errorMessages.title && (
                    <div className="form-error-messages captions">Please select Title.</div>
                  )}
                </Col>
              </FormGroup>
              <FormGroup controlId="fullName" className="row">
                <Col sm={4}>
                  <ControlLabel className='body-semibold'>
                    Full Name
                    <i className="form-mandatory-fields">*</i>
                  </ControlLabel>
                </Col>
                <Col sm={6}>
                  <FormControl type="text"
                    placeholder="John Smith"
                    name="name"
                    disabled = {this.props.disabled.name}
                    className={nameClass}
                    value={this.props.customerDetails.name || ""}
                    onChange={(e)=>{this.props.onInputChange(e)}}
                  />
                  {
                    this.props.errorMessages.name &&
                    <div className="form-error-messages captions">Please enter your first and last name.</div>
                  }
                </Col>
              </FormGroup>
              <FormGroup controlId="contactNumber" className="row">
                <Col sm={4}>
                  <ControlLabel className='body-semibold' >
                    Contact Phone No.
                    <i className="form-mandatory-fields">*</i>
                  </ControlLabel>
                </Col>
                <Col sm={6}>
                  <FormControl type="text" className={mobileNumberClass} placeholder="0400 000 000" name="mobileNumber" disabled = {this.props.disabled.mobileNumber}
                  value={this.props.customerDetails.mobileNumber || ""} onChange={(e)=>{this.props.onInputChange(e)}}/>
                  {
                    this.props.errorMessages.mobileNumber &&
                    <div className="form-error-messages captions">Please enter your phone number.</div>
                  }
                </Col>
              </FormGroup>
              <FormGroup controlId="email" className="row">
                <Col sm={4}>
                  <ControlLabel className='body-semibold'>
                    Email Address
                    <i className="form-mandatory-fields">*</i>
                  </ControlLabel>
                </Col>
                <Col sm={6}>
                  <FormControl type="email" placeholder="email@email.com" className={emailClass} name="email" disabled = {this.props.disabled.email}
                  value={this.props.customerDetails.email || ""} onChange={(e)=>{this.props.onInputChange(e)}}/>
                  {
                    this.props.errorMessages.email &&
                    <div className="form-error-messages captions">Please enter your email address.</div>
                  }
                </Col>
              </FormGroup>
              <FormGroup controlId="preferredContact" className="row">
                <Col sm={4}>
                  <ControlLabel>
                    <span className="margin-right-5 body-semibold">
                      Preferred Contact
                      <i className="form-mandatory-fields">*</i>
                    </span>
                    <InfoTooltip text={tooltipContact}>
                      <span>
                        <i className="far fa-question-circle tooltip-icon" aria-hidden="true"></i>
                      </span>
                    </InfoTooltip>
                  </ControlLabel>
                </Col>
                <Col sm={6}>
                    <FormControl componentClass="select"  name="preferredContact" value={this.props.customerDetails.preferredContact || 'email'} onChange={(e)=>{this.props.onInputChange(e)}}>
                      <option value="email">Email</option>
                      <option value="phone">Phone</option>
                    </FormControl>
                </Col>
              </FormGroup>
              {
                this.props.manualEntry === false &&
                <FormGroup controlId="mailingAddress" className="row">
                  <Col sm={4}>
                    <ControlLabel className='body-semibold'>
                      Mailing Address
                      <i className="form-mandatory-fields">*</i>
                    </ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <FormControl type="text" autoComplete="new-singleAddressLine" disabled = {this.props.disabled.singleAddressLine}
                      placeholder="Enter Address" className={singleAddressLineClass} name="singleAddressLine" value={this.props.customerDetails.singleAddressLine || ""}
                      onChange={(e)=>{this.props.onAddressInputChange(e)}} onFocus={()=>{this.props.onAddressFocus()}}/>
                      {
                        this.props.errorMessages.singleAddressLine &&
                        <div className="form-error-messages captions">
                          {
                            containsPOBox(this.props.customerDetails.singleAddressLine) ?
                            'Mailing cannot be a PO BOX, please provide a physical address, eg 1 Smith Street Southport QLD 4215' :
                            'Please select your address or click \'Enter address manually\''
                          }
                        </div>
                      }
                      {
                        (!this.props.disabled.singleAddressLine && !this.props.forceAddressManualEntry()) &&
                        <p className="grey-link text-left no-padding" style={{margin:'5px 0 0 0'}} onClick={()=>{this.props.onAddressManualEntry()}}>Enter address manually</p>
                      }
                      {
                        this.props.addressOption && this.props.address && this.props.address.length>0 &&
                        <div className="custom-autocomplete text-left">
                          {
                            this.props.address.map(function(line, index){
                              return(
                                  <div key={index} className="custom-autocomplete-row" onClick={()=>{this.props.onAddressSelection(line)}}>
                                    {line.suggestion.replace(/\//g, ", ")}
                                  </div>
                              )
                            },this)
                          }
                        </div>
                      }
                  </Col>
                </FormGroup>
              }

              {
                this.props.manualEntry &&
                <div>
                  <FormGroup controlId="street" className="row">
                    <Col sm={4}>
                      <ControlLabel>
                        <span className="margin-right-5 body-semibold">
                          Street Address
                          <i className="form-mandatory-fields">*</i>
                        </span>
                        <InfoTooltip text={tooltipStreetAddress}>
                          <span>
                            <i className="far fa-question-circle tooltip-icon" aria-hidden="true"></i>
                          </span>
                        </InfoTooltip>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl
                        type="text"
                        name="streetAddress"
                        className={streetAddressClass}
                        value={this.props.customerDetails.streetAddress || ""}
                        onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.streetAddress &&
                        <div className="form-error-messages captions">
                          {
                            !containsPOBox(this.props.customerDetails.streetAddress) ?
                            'Please enter your street address.' :
                            'Street cannot be a PO BOX, please provide a physical address, eg 1 Smith Street'
                          }
                        </div>
                      }
                      {
                        this.props.errorMessages.streetAddressFormat &&
                        <div className="form-error-messages captions">Only special characters "," and "-" are accepted in Street Address.</div>
                      }
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="suburb" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        Suburb
                      <i className="form-mandatory-fields">*</i></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl
                        type="text"
                        name="suburbCity"
                        className={suburbCityClass}
                        value={this.props.customerDetails.suburbCity || ""}
                        onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.suburbCity &&
                        <div className="form-error-messages captions">Please enter your suburb.</div>
                      }
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="state" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        State
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                    <FormControl componentClass="select" className={stateClass} name="state" value={this.props.customerDetails.state || ""} onChange={(e)=>{this.props.onInputChange(e)}}>
                      <option value="null">--Select State--</option>
                      <option>QLD</option>
                      <option>NSW</option>
                      <option>ACT</option>
                      <option>VIC</option>
                      <option>TAS</option>
                      <option>SA</option>
                      <option>WA</option>
                      <option>NT</option>
                    </FormControl>
                    {
                      this.props.errorMessages.state &&
                      <div className="form-error-messages captions">Please select the state.</div>
                    }
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="postcode" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        Postcode
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl
                        type="text"
                        name="postcode"
                        className={postcodeClass}
                        value={this.props.customerDetails.postcode || ""}
                        onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.postcode &&
                        <div className="form-error-messages captions">Please enter your postcode.</div>
                      }
                      {
                        !this.props.forceAddressManualEntry() &&
                        <p className="grey-link text-left no-padding" style={{margin:'5px 0 0 0'}} onClick={()=>{this.props.onAddressCancelManualEntry()}}>Cancel manual address entry</p>
                      }
                    </Col>
                  </FormGroup>
                </div>
              }

              {
                this.props.showBusinessOption &&
                <FormGroup controlId="preferredContact" className="row">
                  <Col sm={4}>
                    <ControlLabel>
                      <span className="body-semibold">
                        Business or Personal Use?
                        <i className="form-mandatory-fields">*</i>
                      </span>
                    </ControlLabel>
                  </Col>
                  <Col sm={6}>
                      <FormControl
                        componentClass="select"
                        name="business"
                        value={this.props.business===true || this.props.totalPrice == 0 ? "Business":"Personal"}
                        onChange={(e)=>{this.props.onChangeBusinessOption(e)}}>
                        <option value="Business">Business</option>
                        {this.props.totalPrice > 0 && <option value="Personal">Personal</option>}
                      </FormControl>
                  </Col>
                </FormGroup>
              }
              {
                this.props.business === false &&
                <IndustrySelector
                  onInputChange={this.props.onInputChange}
                  customerDetails={this.props.customerDetails}
                  errorMessages={this.props.errorMessages}
                  containsRPPTrial={this.props.totalPrice == 0}
                />
              }
            </div>
          </div>
          <hr/>
          {
            this.props.business &&
            <div className="row no-margin">
              <div className="col-sm-12 no-padding">
                <div className="row no-margin">
                  <div className="col-xs-12 no-padding">
                    <div className="section-header heading3 registration-h6">
                      <img src={locationCityIcon}/>
                      Business / Office
                    </div>
                  </div>
                </div>
                <FormGroup controlId="role" className="row">
                  <Col sm={4}>
                    <ControlLabel>
                      <span className="margin-right-5 body-semibold">
                        Position / Role
                      </span>
                      <i className="form-mandatory-fields">*</i>
                    </ControlLabel>
                  </Col>
                  <Col sm={6}>
                      <FormControl
                        className={roleClass}
                        name="role"
                        componentClass="select"
                        disabled = {this.props.disabled.role}
                        value={this.props.customerDetails.role || ""}
                        onChange={(e)=>{this.props.onInputChange(e)}}>
                        <option value="null">--Select Role--</option>
                        <option value="ACCOUNTANT">Accountant</option>
                        <option value="ACCOUNTS_PAYABLE_OFFICER">Accounts Payable Officer</option>
                        <option value="ADMINISTRATOR">Administrator</option>
                        <option value="BUSINESS_OWNER">Business Owner</option>
                        <option value="CONSULTANT">Consultant</option>
                        <option value="DIRECTOR">Director</option>
                        <option value="MANAGER">Manager</option>
                        <option value="OWNER">Owner</option>
                        <option value="STAFF">Staff</option>
                        <option value="USER">User</option>
                      </FormControl>
                      {
                        this.props.errorMessages.role &&
                        <div className="form-error-messages captions">Please select your position or role.</div>
                      }
                  </Col>
                </FormGroup>
                {
                  this.props.abnManualEntry === false &&
                  <FormGroup controlId="abn" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        ABN / ACN
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl type="text" name="abn" className={abnClass} value={this.props.customerDetails.abn || ""}
                        onChange={(e)=>{this.props.onInputChange(e)}} disabled={this.props.disabled.abn} autoComplete="off" autoCorrect="off" />
                        {
                          (this.props.errorMessages.abn ||  this.props.errorMessages.abnInvalid) &&
                          <div className="form-error-messages captions">Please enter a valid ABN / ACN or click 'Enter business details manually'</div>
                        }
                        {
                          this.props.errorMessages.abnFormat &&
                          <div className="form-error-messages captions">ABN format: 12345678901 or 12 123 456 789.<br/> ACN format: 123456789 or 123 456 789</div>
                        }
                    </Col>
                  </FormGroup>
                }
                {
                  this.props.abnManualEntry===false &&
                  <div className="row form-group" style={{marginTop: this.state.mobile ? '15px' : '20px'}}>
                    <div className={abnManualTextClassLabel}>
                      {
                        this.props.abnManualEntry===false && this.props.customerDetails.businessName!=null && this.props.customerDetails.businessName !== "" &&
                        <p className='body-semibold'>
                          Business Name
                          <i className="form-mandatory-fields">*</i>
                        </p>
                      }
                    </div>
                    <div className={abnManualTextClassValue} style={{textAlign:'left'}}>
                        {
                          this.props.abnManualEntry===false && this.props.customerDetails.businessName!=null && this.props.customerDetails.businessName !== "" &&
                          <p style={{padding: this.state.mobile?'0px 0px 0px 15px': '',"minHeight":"30px"}}>{this.props.customerDetails.businessName}</p>
                        }
                    </div>
                  </div>
                }
                {
                  this.props.abnManualEntry===false &&
                  <div className="row form-group">
                    <div className={abnManualTextClassLabel}>
                      {
                        this.props.abnManualEntry===false && this.props.customerDetails.legalEntityName!=null && this.props.customerDetails.legalEntityName !== "" &&
                        <p className='body-semibold'>
                          Legal Entity Name
                          <i className="form-mandatory-fields">*</i>
                        </p>
                      }
                    </div>
                    <div className={abnManualTextClassValue} style={{textAlign:'left'}}>
                        {
                          this.props.abnManualEntry===false && this.props.customerDetails.legalEntityName!=null && this.props.customerDetails.legalEntityName !== "" &&
                          <p className="checkout-body" style={{padding: this.state.mobile?'0px 0px 0px 15px': ''}}>{this.props.customerDetails.legalEntityName}</p>
                        }
                        {
                          !this.props.abnError && !this.props.disabled.abn &&
                          <p className="grey-link text-left no-paddin captions" style={{margin: this.state.mobile?'-5px 0 0px 10px':'-5px 0 0px -5px'}} onClick={()=>{this.props.onAbnManualEntry()}}>
                            Enter business details manually
                          </p>
                        }
                    </div>
                  </div>
                }
                {
                  this.props.abnManualEntry &&
                  <div>
                  <FormGroup controlId="abnManual" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        ABN / ACN
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl type="text" name="abnManual" className={abnManualClass}
                        value={this.props.customerDetails.abn || ""} onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.abnManual &&
                        <div className="form-error-messages captions">Please enter your ABN / ACN.</div>
                      }
                      {
                        this.props.errorMessages.abnFormat &&
                        <div className="form-error-messages captions">ABN format: 12345678901 or 12 123 456 789.<br/> ACN format: 123456789 or 123 456 789</div>
                      }
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="businessName" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        Business / Trade Name
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl type="text" name="businessName" className={businessNameClass}
                         value={this.props.customerDetails.businessName || ""} onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.businessName &&
                        <div className="form-error-messages captions">Please enter your business name.</div>
                      }
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="legalEntityName" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        Legal Entity Name
                        <i className="form-mandatory-fields">*</i>
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <FormControl type="text" name="legalEntityName" className={legalEntityNameClass}
                        value={this.props.customerDetails.legalEntityName || ""} onChange={(e)=>{this.props.onInputChange(e)}}/>
                      {
                        this.props.errorMessages.legalEntityName &&
                        <div className="form-error-messages captions">Please enter your legal entity name.</div>
                      }
                      {
                        !this.props.abnError &&
                        <p className="grey-link text-left no-padding" style={{margin:'5px 0 0 0'}} onClick={()=>{this.props.onAbnCancelManualEntry()}}>
                          Cancel manual business details entry
                        </p>
                      }
                    </Col>
                  </FormGroup>
                </div>
                }
                {
                  this.props.business === true &&
                  <IndustrySelector
                    onInputChange={this.props.onInputChange}
                    customerDetails={this.props.customerDetails}
                    errorMessages={this.props.errorMessages}
                    containsRPPTrial = {this.props.containsRPPTrial}
                  />
                }
                {
                  this.props.rppProduct === "real_estate_agencies_and_valuers" &&
                  this.props.customerDetails.accountType == "NEW_ACCOUNT" &&
                  <FormGroup controlId="franchiseGroup" className="row">
                    <Col sm={4}>
                      <ControlLabel className='body-semibold'>
                        Franchise Group
                      </ControlLabel>
                      <br/>
                      <div className="optional-text footnote-text">Optional</div>
                    </Col>
                    <Col sm={6}>
                      <Typeahead
                        autoComplete="false"
                        onChange={(e)=>{this.props.onInputChange(e,'franchise')}}
                        selected={this.props.customerDetails.franchiseGroup?[this.props.customerDetails.franchiseGroup]:[]}
                        labelKey="franchiseGroup"
                        options={["ACTON","AON","BARRY PLANT","BELLE PROPERTY","BIGGIN & SCOTT","BUXTON","CB RICHARD ELLIS","CENTURY 21","COLLIERS","CORONIS","DOWLING","Elders","EVIEW","FIRST NATIONAL","FLETCHERS","GEORGE BRAND","GO GECKO","Harcourts","HERRON TODD WHITE","HOCKING STUART","HODGES","JELLIS CRAIG","KNIGHT FRANK","LAING + SIMMONS","LANDMARK HARCOURTS","LANDMARK WHITE","Little Real Estate","LJ HOOKER","LMW Hegney","MCGEES","MCGRATH","MVS VALUERS","NELSON ALEXANDER","NOEL JONES","ONE AGENCY","OPTEON","PLACE ESTATE","AGENTS","PRD Nationwide","PRESTON ROWE","Professionals","PROPELL VALUERS","RAINE & HORNE","RAY WHITE","RE/MAX","REALMARK","REALWAY","RICHARDSON & WRENCH","ROBERTS LIMITED","RT EDGAR","Ruralco","SAVILLS","Sell Lease Property","STARR PARTNERS","STOCKDALE & LEGGO","TAYLOR BYRNE","TOOP & TOOP","WOODARDS","YPA ESTATE AGENTS","ML-INVESTOR","Property Meeting Group","SWEENEYS","AFG","AUSSIE","BGL","CHOICE AGGREGATION","Choice Home Loans","CONNECTIVE","FAST AGGREGATION","FINSURE","HSBC BANK","ING DIRECT","LOAN MARKET GROUP","Loankit","MORTGAGE CHOICE","Mortgage House","NATIONAL MORTGAGE BROK","PLAN AUSTRALIA","Police Bank Franchise","RABOBANK","Smartline Gallery","SPECIALIST FINANCE GROUP","SUNCORP METWAY","VOW Group","Yellow Brick Road","LENDLEASE","MIRVAC"]}
                      />

                    </Col>
                  </FormGroup>
                }
                <FormGroup>
                  <Col className={businessCheckbox}>
                    <Checkbox name="businessTerms" id="businessTerms" onClick={(e)=>{this.props.onInputChange(e)}}><span className={businessTermsClass}>I'm authorised to enter this contract on behalf of this business</span></Checkbox>
                  </Col>
                </FormGroup>
              </div>
            </div>
          }
          {
            this.props.business &&
            <hr/>
          }
          {
            this.props.totalPrice > 0 &&
            <div className="row no-margin">
              <div className="col-sm-12 no-padding">
                <div className="row no-margin">
                  <div className="section-header heading3 registration-h6">
                    <img src={creditCardIcon}/>
                    Confirm Order
                  </div>
                </div>

                <div className="row no-margin">
                  <div className={paymentSectionClass}>
                    {
                      this.props.conditionalTC === true && this.props.quotes !== undefined && this.props.quotes.length > 0 &&
                      <div>
                        {
                          this.props.quotes.map(function(item, index){
                            return(
                              <div key={index}>
                                {
                                  item.contractMonths >= 6 &&
                                  <TncGeneral
                                    conditionalTC={this.props.conditionalTC}
                                    headline={item.headline} totalMonths={item.userContractMonths}
                                    totalDays={item.contractMonths>=12?'90':'30'}
                                    couponEntity={this.props.couponEntity}
                                    isReport={item.productGroup === "Report Subscription"}
                                    yearlyDiscount = {item.yearlyDiscount}
                                    totalPerMonth={item.originalPrice}
                                    isRPP={this.props.isRPP}
                                  />
                                }
                                {
                                  item.contractMonths === 0  &&
                                  <TncTrial conditionalTC={this.props.conditionalTC} headline={item.headline} industry={this.props.customerDetails.industry}/>
                                }
                                {
                                  item.contractMonths >= 1  && item.contractMonths < 6 &&
                                  <TncOneMonth conditionalTC={this.props.conditionalTC} headline={item.headline} totalMonths={item.userContractMonths} totalDays='30'/>
                                }
                              </div>
                            )
                          },this)
                        }
                      </div>
                    }
                    {
                      this.props.conditionalTC === false && (this.props.userTotalMonths >= 6) &&
                      <TncGeneral
                        totalMonths={this.props.userTotalMonths}
                        totalDays={this.props.totalDays} couponEntity={this.props.couponEntity}
                        isReport={this.props.isReport}
                        yearlyDiscount = {this.props.isYearlyCouponApplied()}
                        totalPerMonth={this.props.originalTotalPrice}
                        isRPP={this.props.isRPP}
                      />
                    }
                    {
                      this.props.conditionalTC === false && this.props.userTotalMonths >= 1 && this.props.userTotalMonths < 6 &&
                      <TncOneMonth totalMonths={this.props.userTotalMonths} totalDays='30'/>
                    }
                    <FormGroup className="row no-margin">
                      <Col sm={12}>
                        <Checkbox id="chkTerms" name="terms" onClick={(e)=>{this.props.onInputChange(e)}}><span className={termsClass}>By proceeding to payment, you acknowledge and agree to the <a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a> and <a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></span></Checkbox>
                      </Col>
                    </FormGroup>
                    {
                      new Date() < new Date("2019/07/16") &&
                      <FormGroup className="row no-margin">
                        <Col sm={12} className="discount-alert blue-bg coupon-box captions-semibold">
                          <Checkbox id="coupon-box" name="endOFYearCoupon" checked={eofycouponApplied} onClick={(e)=>{this.props.onCouponInputChange(e)}}>
                            <p className="no-margin padding-left" style={{fontSize:'12px'}}>End of Financial Year Offer</p>
                            <p className="font-10 no-margin padding-left">Check this box if you would like to pay total contract value in a single transaction</p>
                            <p className="font-10 no-margin padding-left">Receive 20% off your entire order! This offer cannot be used in conjunction with any other offer. The discount is only for the initial period of 12 months.</p>
                            <p className="font-10 no-margin padding-left">This offer only applies to Cityscope, Cordell Connect, Cordell Estimator Platinum, Lease Expiry Diary, RP Data.</p>
                          </Checkbox>
                        </Col>
                      </FormGroup>
                    }

                  </div>
                </div>
              </div>
            </div>
          }
          {
            this.props.totalPrice === 0 &&
            <div className="row no-margin">
              <div className="col-sm-12 no-padding">
                <div className="row no-margin">
                  <div className="section-header heading3 registration-h6">
                    <img src={creditCardIcon}/>
                    Confirm Order
                  </div>
                </div>
                <div className="row no-margin padding-15">
                  <div className="col-sm-12 terms-cond footnote-text">
                    <div>TERMS & CONDITIONS</div>
                    <ul className="list-padding">
                      <li>I warrant I am authorised to enter this contract on behalf of the business;</li>
                      <li>I agree to be bound by this contract with RP Data Pty Ltd t/a Cotality ; and</li>
                      <li>I acknowledge this contract comprises of:
                        <ul>
                          <li>Commercial terms on this page;</li>
                          <li><a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a>; and</li>
                          <li><a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>; and</li>
                        </ul>
                      </li>
                      {
                        this.props.customerDetails.industry === 'INVESTOR' &&
                        <li>
                          The Cotality Service provided for Investor trials is limited to a single sample suburb and for a single Trial Period of 7 days, after which your access will automatically be disconnected.
                        </li>
                      }
                      {
                        this.props.customerDetails.industry !== 'INVESTOR' &&
                        <>
                          <li>
                            The Cotality Service provided for Business trials is only available for business customers who hold a valid ABN. Business trial requests are subject to Cotality's approval.
                          </li>
                          <li>
                            The Trial Period and geographic access provided as the Cotality Services for Business trials will vary at the discretion of your Cotality Salesperson, and access will automatically be disconnected at the end of the Trial Period.
                          </li>
                        </>
                      }
                    </ul>
                  </div>
                </div>
                <FormGroup className="row no-margin" style={{padding: "0px 15px"}}>
                  <Col sm={12}>
                    <Checkbox id="chkTerms" name="trialTerms" className={trialTermsClass} onClick={(e)=>{this.props.onInputChange(e)}}>By submitting this request, you acknowledge and agree to the <a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a> and <a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></Checkbox>
                  </Col>
                </FormGroup>

              </div>
            </div>
          }
          <hr/>
          {
            this.props.totalPrice > 0 &&
            <div>
              <div className="row no-margin">
                <a id="view-order-summary-btn"className="btn btn-outline-20 float-right checkoutpage-btn" style={{padding:'5px 12px'}} onClick={this.orderSummaryFocus}>
                  View Order Summary
                </a>
                <button id="btn_submit" type="button"
                  className={this.props.submitLoader ? 'btn btn-primary float-right disabled checkoutpage-btn' : 'btn btn-primary float-right checkoutpage-btn'}
                  onClick={()=>{this.props.onSubmitCustomerDetails("credit")}}>
                  Proceed to Payment
                  {
                    this.props.submitLoader &&
                    <span>
                        <i className="fa fa-spinner fa-pulse fa-fw"></i>
                        <span className="sr-only">Loading...</span>
                      </span>
                  }
                </button>
                <button id="btn_cart" type="button" className="btn btn-outline-20 float-right checkoutpage-btn" style={{padding:'5px 12px'}} onClick={() => {this.props.backToCart()}}>
                  Back to Cart
                </button>
              </div>
              {
                this.props.errors &&
                <div>
                  <ErrorMessages errorMessages={this.props.errorMessages}/>
                </div>
              }
            </div>
          }
          {
            this.props.totalPrice === 0 &&
            <div>
            <div className="row no-margin">
              <button id="btn_submit"  type="button"
              className={this.props.submitLoader ? 'btn btn-primary float-right disabled checkoutpage-btn' : 'btn btn-primary float-right checkoutpage-btn'}
              onClick={()=>{this.props.onSubmitCustomerDetails("trial")}}>
                Submit Request
                {
                  this.props.submitLoader &&
                  <span>
                      <i className="fa fa-spinner fa-pulse fa-fw"></i>
                      <span className="sr-only">Loading...</span>
                    </span>
                }
              </button>
              <button id="btn_cart" type="button" className="btn btn-outline-20 float-right checkoutpage-btn" style={{padding:'5px 12px'}}  onClick={() => {this.props.backToCart()}}>
                Back to Cart
              </button>
            </div>
            {
              this.props.errors &&
              <ErrorMessages errorMessages={this.props.errorMessages}/>
            }
          </div>
          }

        </form>
      </div>
    )
  }
}
